import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-checkbox-checked",
  "use": "icon-checkbox-checked-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-checkbox-checked\"><path d=\"M24 0v24H0V0h24zm-3.987 7.293a.999.999 0 00-1.414 0l-8 8c-.185.186-.329.187-.515 0l-4.377-4.377a.999.999 0 10-1.414 1.414l4.377 4.378c.446.446 1.04.692 1.671.692.632 0 1.226-.246 1.671-.692l8.001-8.001a.999.999 0 000-1.414z\" fill=\"#037BFF\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol